<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useAccessToAuction } from '@autobid/ui/composables/useAccessToAuction'
import AuctionDescriptions from '../shared/AuctionDescriptions.vue'
import AuctionListItemNotice from './AuctionListItemNotice.vue'
import AuctionListItemTitle from './AuctionListItemTitle.vue'

const auction = inject<PreparedAuctionItem>('auction')

const { isAuthed } = useAutobidAuth()

const accessToAuction = useAccessToAuction({
  restrictions: auction?.restrictions,
  appId: auction?.appId,
  isAuthed,
})
</script>

<template>
  <div
    class="flex h-full w-full flex-col items-center justify-between gap-2 bg-white p-2 group-hover:bg-slate-100 @lg:flex-row"
  >
    <div class="flex flex-wrap gap-2 @lg:w-[20%]">
      <img
        v-for="logo in auction?.logos"
        :key="logo.url"
        :src="logo.url"
        class="h-auto"
        :alt="logo.alt"
      >
    </div>

    <div
      class="flex h-full w-full flex-col justify-center @sm:w-1/2 @md:w-[80%]"
    >
      <div>
        <AuctionListItemTitle :as-link="auction?.type !== 'LIVE' || (isAuthed && accessToAuction.statusCode === 200)" />
        <AuctionDescriptions :descriptions="auction?.descriptions || []" />
      </div>

      <AuctionListItemNotice v-if="auction?.notice" v-bind="auction.notice" />
    </div>
  </div>
</template>
